type AddressLike = {
  street?: string | null;
  house_number?: string | null;
  city?: string | null;
  postal_code?: string | null;
} | null;

type BranchLike = {
  latitude?: number | null;
  longitude?: number | null;
  address?: AddressLike;
};

export default function getCustomerParcelShopMapUrl(branch: BranchLike): string | null {
  if (branch.latitude && branch.longitude) {
    return `https://www.google.com/maps/search/?api=1&query=${branch.latitude},${branch.longitude}`;
  }
  if (branch.address) {
    const query = encodeURIComponent(
      `${branch.address.street ?? ''} ${branch.address.house_number ?? ''}, ${branch.address.postal_code ?? ''} ${
        branch.address.city ?? ''
      }`.trim(),
    );
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
  }
  return null;
}
